




































import { Component, PropSync, Ref, Vue } from 'vue-property-decorator'
import {NumberWings} from "@/components";
import { Action } from 'vuex-class';
import { notifyError } from '@/utils/notify-helper';

@Component({components: {NumberWings}})
export default class TopUpDialog extends Vue {
  @Ref('validator') validator:any;
  @PropSync('show') active!: boolean;

  @Action("getPaymentAggregators") actionPaymentAggregators: any;
  @Action("paymentSession") actionPaymentSession: any;

  paymentAggregatorsList = []
  paymentAggregator = ''

  form = {
    amount: undefined,
    currency: 'eur',
    url: window.location.href
  }

  setActive(name: string) {
    this.paymentAggregator = name
  }

  isActive(name: string) {
    return this.paymentAggregator == name
  }

  getImage() {
    return `${process.env.BASE_URL}ps/stripe.png`
  }

  async created() {
    this.paymentAggregatorsList = await this.actionPaymentAggregators()
    if (this.paymentAggregatorsList.length) {
      //@ts-ignore
      this.paymentAggregator = this.paymentAggregatorsList[0]?.name
    }
  }

  async proceed() {
    if (!await this.validator.validate()) {
      return
    }
    try {
      const resp = await this.actionPaymentSession(this.form)
      if (resp.status == 'success' && resp.checkout_url) {
        window.location.href = resp.checkout_url
      }
    } catch(error) {
      notifyError(error);
    }
  }
}
